/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useState } from 'react';
import AgentFormModal from './AgentFormModal';
import { TableCell, TableRow } from './ui/table';
import { Button } from './ui/button';
import MortgageCompanyFormModal from './MortgageCompanyFormModal';
import { Input } from './ui/input';
import { toast } from './ui/sonner';
import { FaRegCopy } from 'react-icons/fa6';

interface Props {
  row: any;
}

const MortgageCompanyTableRow: FC<Props> = ({ row }) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const handleCopyLink = () => {
    const url = `${window.location.origin}?mortgage=${row?._id}`;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast.success('Copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <>
      <TableRow className="hover:bg-muted/30 cursor-pointer transition-colors">
        <>
          <TableCell className="py-3">{row.name}</TableCell>
          <TableCell className="py-3">{row.emailAddress}</TableCell>
          <TableCell className="py-3">{row.phoneNumber ?? 'Unknown'}</TableCell>
          <TableCell className="py-3">
            <div className="flex flex-col md:flex-row items-end gap-4">
              <div className="space-y-2 flex-1 w-full">
                <Input
                  id="identifier"
                  name="identifier"
                  value={`${window.location.origin}?mortgage=${row?._id}`}
                  disabled
                />
              </div>
              <Button
                className="bg-transparent text-tax-actionRed hover:text-white"
                type="button"
                onClick={handleCopyLink}
              >
                <FaRegCopy className="" />
              </Button>
            </div>
          </TableCell>
          <TableCell className="py-3 flex justify-end">
            <Button
              onClick={() => setShowUpdateModal(true)}
              className="py-1 h-fit"
            >
              Edit Mortgage Company
            </Button>
          </TableCell>
        </>
      </TableRow>
      <MortgageCompanyFormModal
        mortgageCompany={row}
        isOpen={showUpdateModal}
        setIsOpen={setShowUpdateModal}
      />
    </>
  );
};

export default MortgageCompanyTableRow;
